"use client"

import { FC, useMemo } from "react"
import { advantages as staticAdvantages } from '@/src/utils/advantagesHelper'
import { useContent } from "@/src/context/ContentContext"

const Advantages: FC = () => {
  const { advantages } = useContent()

  const items = useMemo(() => {
    return staticAdvantages.map((adv, i) => ({
      ...adv,
      title: advantages.items[i]?.title ?? adv.title,
      description: advantages.items[i]?.description ?? adv.description,
    }))
  }, [advantages.items])

  return (
    <section
      id="advantages"
      className="py-8 lg:py-4 min-h-screen flex items-center bg-gradient-to-b from-[#111216] via-[#181b20] to-[#1e2126]"
      aria-labelledby="advantages-title"
    >
      <div className="container mx-auto">
        <div className="text-center mb-16">
          <h2
            id="advantages-title"
            className="text-3xl lg:text-4xl font-semibold text-white mb-6"
          >
            {advantages.sectionTitle}
          </h2>
        </div>
        <ul
          className="grid md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4 gap-6 lg:gap-8 list-none"
          aria-labelledby="advantages-title"
        >
          {items.map((advantage) => {
            const IconComponent = advantage.icon
            return (
              <li key={advantage.id} className="group transition-transform hover:-translate-y-1">
                <div
                  className="bg-[#262a2f] p-6 rounded-2xl border border-[#373b42] group-hover:border-[#4a4e55] shadow-[0_0_6px_#1b1d22] hover:shadow-[0_0_10px_#2c2f35] transition-all duration-300 h-full flex flex-col relative overflow-hidden"
                  aria-label={`Перевага: ${advantage.title}`}
                >
                  <div className="rounded-xl mb-4 mx-auto flex items-center justify-center w-16 h-16 bg-[#363a40] group-hover:bg-[#44484f] transition-colors">
                    <IconComponent
                      className="w-10 h-10 text-white"
                      aria-hidden="true"
                      focusable="false"
                    />
                  </div>
                  <h3 className="text-center text-lg font-medium text-white mb-3 leading-tight">
                    {advantage.title}
                  </h3>
                  <p className="text-center font-light text-gray-200 leading-relaxed text-sm flex-grow">
                    {advantage.description}
                  </p>
                  <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-[#545860] to-[#6a6f78] group-hover:from-white/40 group-hover:to-white/60 transition-all duration-300" />
                </div>
              </li>
            )
          })}
        </ul>
      </div>
    </section>
  )
}

export default Advantages
